import { render, staticRenderFns } from "./ScientificTopics.vue?vue&type=template&id=0f7d4c49&"
import script from "./ScientificTopics.vue?vue&type=script&lang=js&"
export * from "./ScientificTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports